import React, { useState } from 'react';

import IconAction from '../IconAction';
import MobileNavOverlay from '../mobile/MobileNavOverlay';
import { telemetryClickHandler } from '../telemetryHandler';
import type { TabletNavConfig } from '../types';

interface TabletNavActionsProps {
  config: TabletNavConfig;
  logoUrl: string;
}

export default function TabletNavActions({
  config,
  logoUrl,
}: TabletNavActionsProps): JSX.Element {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <div className="hidden items-center gap-6 topnav-sm:flex topnav-md:hidden">
        {config.actions.map((item) => {
          if (item.type === 'link') {
            return (
              <a
                key={item.href}
                href={item.href}
                className="text-base font-normal text-gray-900 hover:opacity-80"
                onClick={telemetryClickHandler(
                  item.telemetrySlug,
                  item.telemetryEvents
                )}
              >
                {item.label}
              </a>
            );
          }

          if (item.type === 'cta') {
            return (
              <a
                key={item.href}
                href={item.href}
                className="flex h-10 items-center justify-center rounded-10px bg-yellow-400 px-6 text-sm font-semibold text-gray-900 hover:bg-yellow-500"
                onClick={telemetryClickHandler(
                  item.telemetrySlug,
                  item.telemetryEvents
                )}
              >
                {item.label}
              </a>
            );
          }

          return <IconAction key={item.href} item={item} />;
        })}

        <button
          type="button"
          onClick={(): void => setIsMenuOpen(true)}
          aria-label="Open menu"
        >
          <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
            <path
              d="M2 4H14M2 8H14M2 12H14"
              stroke="#1F2830"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <MobileNavOverlay
        isOpen={isMenuOpen}
        onClose={(): void => setIsMenuOpen(false)}
        navItems={config.hamburgerNavItems}
        bottomActions={config.overlayActions}
        logoUrl={logoUrl}
      />
    </>
  );
}
